<div class="date-picker-container" [class.error-outline]="isError()" [class.disabled]="disabled()">
    <!-- Display overlay showing DD-MM-YYYY format -->
    <!-- <label [attr.for]="inputId" class="date-display" [class.has-value]="displayValue" (click)="openCalendar()">
        {{ displayValue || placeholder() }}
    </label> -->

    <!-- Native date input (transparent overlay for calendar picker) -->
    <input #dateInput type="date" class="native-date-input input-{{ size() }}" [id]="inputId" [name]="name()"
        [value]="internalValue" [disabled]="disabled()" [min]="internalMin()" [max]="internalMax()"
        (change)="onDateChange($event)" (blur)="onBlur()" />
</div>